<template>
  <div style="width: 100%;">
    <v-row no-gutters justify="center" align="center" class="pb-10">
      <img src="@/assets/logo_no_bg.png" class="logo" />
    </v-row>
    <v-row no-gutters justify="center" align="center" class="py-6" v-if="isFetchingSignup">
      <v-progress-circular indeterminate color="accent" />
    </v-row>
    <div v-else-if="error.length">
      <v-row no-gutters justify="center" align="center">
        <v-alert
          text
          :icon="false"
          type="error"
          style="max-width: 400px;"
        >
          <div slot="prepend" class="pr-3">
            🤔
          </div>
          {{ error }}
        </v-alert>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-6">
        <v-btn
          rounded
          depressed
          small
          color="primary"
          class="submit-btn"
          @click="openCrisp"
        >
          Contacter le support
        </v-btn>
      </v-row>
    </div>
    <div v-else-if="isFinalizingSpace">
      <v-row no-gutters justify="center" align="center">
        <v-progress-circular color="accent" size="25" indeterminate class="mr-2" />
      </v-row>
      <div class="text-center font-weight-medium pt-8">
        Vérification de votre e-mail et réglages des derniers détails...
      </div>
    </div>
    <v-row no-gutters justify="center" align="center" v-else>
      <div>
        <div class="text-center text-h6">
          🌟 Tout est bon pour nous 🌟
        </div>
        <v-row no-gutters justify="center" align="center" class="pt-10">
          <v-btn
            rounded
            depressed
            large
            color="primary"
            class="submit-btn"
            :href="ssoUrl"
          >
            Accéder à mon espace
          </v-btn>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

const DEFAULT_ERROR_MESSAGE = `Impossible de finaliser vore compte`;

export default {
  data: () => ({
    isFetchingSignup: false,
    isFinalizingSpace: false,
    error: ``,
    space: null,
  }),

  computed: {
    ...mapState({
      storeSignup: `signup`,
    }),
    signup: {
      get() { return this.storeSignup; },
      set(value) { return this.SET_SIGNUP(value); },
    },
    token() {
      return this.$route.params?.token || null;
    },
    verifyToken() {
      return this.$route.params?.verifyToken || null;
    },
    hasSignup() {
      return Boolean(this.signup?.token);
    },
    ssoUrl() {
      if (!this.space) { return ``; }

      let ssoUrl = `${this.space.slugUrl}/sso?token=${this.space.ssoToken}&logout=1`;

      if (ssoUrl.indexOf(`http:`) !== 0) {
        const protocol = window.location.protocol; // eslint-disable-line
        ssoUrl = `${protocol}//${ssoUrl}`;
      }

      return ssoUrl;
    },
  },

  methods: {
    ...mapMutations([
      `SET_SIGNUP`,
    ]),
    async fetchSignup() {
      this.isFetchingSignup = true;
      try {
        const { data: signup } = await this.$api.get(`/signup/${this.token}`);
        this.signup = signup;
        if (this.hasSignup) {
          window.$crisp.push([`set`, `user:nickname`, [`${signup.userFirstname} ${signup.userLastname}`]]);
          window.$crisp.push([`set`, `user:email`, [signup.userEmail]]);
        }
      } catch (e) {} // eslint-disable-line
      this.isFetchingSignup = false;
    },
    openCrisp() {
      try {
        window.$crisp.push([`do`, `chat:open`]);
      } catch (e) {} // eslint-disable-line
    },
    async finalizeSpace() {
      this.isFinalizingSpace = true;
      try {
        const { data: { success, error, space } } = await this.$api.post(`/signup/${this.token}/verify`, {
          verifyToken: this.verifyToken,
        });
        if (success && space) {
          this.space = space;
        } else {
          this.error = error || DEFAULT_ERROR_MESSAGE;
        }
      } catch (e) {
        this.error = e?.response?.data?.error || DEFAULT_ERROR_MESSAGE;
      }
      this.isFinalizingSpace = false;
    },
  },

  async beforeMount() {
    await this.fetchSignup();
    if (this.hasSignup) {
      this.finalizeSpace();
    } else {
      this.error = DEFAULT_ERROR_MESSAGE;
    }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 70%;
  max-width: 200px;
}
</style>
